import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatItTabComponent } from './tabs/chat-it-tab/chat-it-tab.component';
import { DedupTabComponent } from './tabs/dedup-tab/dedup-tab.component';
import { MapItTabComponent } from './tabs/map-it-tab/map-it-tab.component';
import { RefreshTabComponent } from './tabs/refresh-tab/refresh-tab.component';
import { RelationsTabComponent } from './tabs/relations-tab/relations-tab.component';
import { SourcesTabComponent } from './tabs/sources-tab/sources-tab.component';
import { NewDataExplorerDetailsPanelComponent } from './details-panel/new-data-explorer-details-panel.component';
import { NewDataExplorerMasterPanelComponent } from './master-panel/new-data-explorer-master-panel.component';
import { NewDataExplorerComponent } from './new-data-explorer.component';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TDGridModule } from '@app/Shared/common-components/td-grid/td-grid.module';
import { DedupPreviewComponent } from './tabs/dedup-tab/dedup-preview/dedup-preview.component';
import { MaterialModule } from '@app/Shared/modules/material.modules';
import { ChildrenSectionComponent } from './tabs/relations-tab/children-section/children-section.component';
import { MergeSectionComponent } from './tabs/relations-tab/merge-section/merge-section.component';
import { ParentSectionComponent } from './tabs/relations-tab/parent-section/parent-section.component';
import { SourceTableComponent } from './tabs/relations-tab/source-table/source-table.component';
import { AgGridModule } from 'ag-grid-angular';
import { GroupDetailCellRendererComponent } from './tabs/relations-tab/shared/group-detail-cell-renderer.component';
import { EditRowTabComponent } from './tabs/edit-row-tab/edit-row-tab.component';
import { ActionComponentsModule } from '@app/Shared/common-components/action-components/action-components.module';

@NgModule({
  declarations: [
    NewDataExplorerComponent,
    NewDataExplorerMasterPanelComponent,
    NewDataExplorerDetailsPanelComponent,
    DedupTabComponent,
    DedupPreviewComponent,
    RelationsTabComponent,
    ParentSectionComponent,
    ChildrenSectionComponent,
    MergeSectionComponent,
    SourceTableComponent,
    GroupDetailCellRendererComponent,
    SourcesTabComponent,
    MapItTabComponent,
    RefreshTabComponent,
    ChatItTabComponent,
    EditRowTabComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    TDGridModule,
    MaterialModule,
    ActionComponentsModule,
    AgGridModule
  ]
})
export class NewDataExplorerModule { }
